"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyPlaceRequestStruct = void 0;
const superstruct_1 = require("superstruct");
const types_1 = require("../types");
exports.CopyPlaceRequestStruct = (0, superstruct_1.type)({
    placeId: (0, superstruct_1.string)(),
    timezone: (0, superstruct_1.string)(),
    organisationId: (0, superstruct_1.string)(),
    wizard: (0, superstruct_1.optional)((0, superstruct_1.type)({
        useQueues: (0, superstruct_1.boolean)(),
        useSchedules: (0, superstruct_1.boolean)(),
        useForms: (0, superstruct_1.boolean)(),
        useInventory: (0, superstruct_1.boolean)(),
    })),
    messagingConfig: (0, superstruct_1.optional)(types_1.MessagingConfigStruct),
    contactDataConfig: (0, superstruct_1.optional)(types_1.ContactDataConfigStruct),
});
//# sourceMappingURL=CopyPlaceRequest.js.map